export const environment = {
  production: true,
  api: 'https://smmserv-api.luxnet.io',
  socketUrl: 'wss://smmserv-api.luxnet.io',
  coderDns: 'https://smmserv-streamer.luxnet.ua',
  coderOutput: 'https://smmserv-streamer.luxnet.ua/news24/output',
  contentOwner: 'u_v73-pNxjnOr5RjtuxyiA',
  fileStorePrefix: 'resources',
  fileStoreDNS: 'https://smmserv.luxnet.io',
  sentryDsn: 'https://45c8af149af3f3db6a2a498646c2417a@sentry.luxnet.ua/10',
  contentStudioAdminUrl: 'https://content-studio.luxnet.dev/'
};
